import React from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const Invoice = () => {
  const generateInvoice = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(20);
    doc.text("Invoice", 20, 20);

    // Client details
    doc.setFontSize(12);
    doc.text("Client Name: John Doe", 20, 40);
    doc.text("Date: " + new Date().toLocaleDateString(), 20, 50);

    // Table
    const tableColumn = ["Item", "Quantity", "Price", "Total"];
    const tableRows = [
      ["Product A", "2", "$10", "$20"],
      ["Product B", "1", "$15", "$15"],
    ];

    doc.autoTable({
      startY: 60,
      head: [tableColumn],
      body: tableRows,
    });

    // Totals
    const finalY = doc.previousAutoTable.finalY;
    doc.text("Subtotal: $35", 20, finalY + 10);
    doc.text("Tax: $3.50", 20, finalY + 20);
    doc.text("Total: $38.50", 20, finalY + 30);

    // Save the PDF
    doc.save("invoice.pdf");
  };

  return (
    <div>
      <button onClick={generateInvoice}>Generate Invoice</button>
    </div>
  );
};

export default Invoice;
